import React from "react";


const NoMatch = () => (
	<div>
		<h1>Page not found</h1>
	</div>
);

export default NoMatch;


// WEBPACK FOOTER //
// ./src/components/NoMatch.js